import React, { useRef } from 'react'
import {
  CloseModal,
  DraftsDescription,
  DraftsImage,
  DraftsLimitContainer,
  DraftsLimitWindow,
  MembershipCircle,
  SubscribeButton,
  Title
} from './DraftsLimitModal.styles'
import draftsMembershipImage from '../../assets/draftsMembership.png'
import membershipIcon from '../../assets/badge_membership_on.png'
import closeIcon from '../../assets/close.svg'
import { useDispatch } from 'react-redux'
import { setShowMembershipModal } from '../../redux/designerReducers/designerReducer'
import useOutsideAlerter from '../../hooks/useOutsideAlerter'

export const DraftsLimitModal = ({ onClose }) => {
  const dispatch = useDispatch()
  const ref = useRef(null)

  useOutsideAlerter(ref, onClose)

  return (
    <DraftsLimitContainer>
      <DraftsLimitWindow ref={ref}>
        <CloseModal onClick={onClose} src={closeIcon} alt="Close" />
        <Title>Drafts Not Available</Title>
        <DraftsImage src={draftsMembershipImage} alt="" />
        <DraftsDescription>
          Draft is only available to members!
          <br />
          Become a member and never worry about
          <br />
          losing a design!
        </DraftsDescription>
        <SubscribeButton
          onClick={() => {
            onClose()
            dispatch(setShowMembershipModal(true))
          }}
        >
          <MembershipCircle>
            <img src={membershipIcon} alt="" />
          </MembershipCircle>
          <span>Become a Member</span>
        </SubscribeButton>
      </DraftsLimitWindow>
    </DraftsLimitContainer>
  )
}
